<template>
	<div class='quiz-eindscherm m-t-md'>
    <div class='quiz-container '>
      <h2 class='eindscherm-eindresultaat '>
        Je had {{correctAnswers}} van de {{totalQuestions}} vragen goed
      </h2>

      <div class='eindscherm-feedback m-t-md' v-html="feedback">
      </div>

      <div class='eindresultaat m-t-lg' v-html="data.outro">
      </div>

      <div class='eindresultaat eindresultaat-advies m-t-lg' v-html="data.adviezen">
      </div>

      <div class='eindresultaat m-t-lg m-b-lg' v-html="data.outro_2">
      </div>

      <div class='knd-eindresultaat'>
        <div class="text-centered paragraph-spacing">
            <h3 class="h3">Meer over dit onderzoek:</h3>
            <a role="article" class="contextual-region tag tag--big" about="/onderzoeken/vet" href="/onderzoeken/vet">
            <span class="sr-only">Bekijk meer artikelen over:</span>
              Vet!
            </a>
          </div>
      </div>

      <div class='knd-credits m-t-lg m-b-lg'>
        <h4>Credits</h4>
        <div v-html="data.credits"></div>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  name: 'index',
  computed: {

    correctAnswers() {
      return this.$store.getters.correctAnswers;
    },

    totalQuestions() {
      return this.$store.getters.totalQuestions;
    }
  },

  watch: {
    '$store.state.correctAnswers': function(value) {
        this.getFeedback(value);
    }
  },

  mounted() {},

  methods: {
    getFeedback(endScore) {   
      let currentData = this.$store.state.data.eindscore;

      let caseMet = false;

      for(var i = 0; i < currentData.length; i++) {
        if(!caseMet && endScore < currentData[i].waarde) {
          this.feedback = currentData[i].feedback;
          caseMet = true;
        }
      }
    }
  },

  data () {
    return {
      data: this.$store.state.data,
      feedback: ''
    }
  }
}
</script>
